import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatRipple } from "@angular/material/core";
import { CdkMonitorFocus } from "@angular/cdk/a11y";

@Component({
    selector: 'lex-icon-button',
    templateUrl: './icon-button.component.html',
    imports: [
        MatRipple,
        CdkMonitorFocus
    ],
    styleUrls: ['./icon-button.component.scss']
})
export class CustomButtonComponent {
	@Input() disabled: boolean = false;
	@Output() buttonClick = new EventEmitter<Event>();

	onClick(event: Event): void {
		if (!this.disabled) {
			this.buttonClick.emit(event);
		}
	}
}
